import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateComponent =() => {

    const auth1 = window.localStorage.getItem('projectUserAuth');
    return auth1 ? <Outlet /> : <Navigate to="/login" />

}

export default PrivateComponent